import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgEditOutline16 = function SvgEditOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.81 11.761.003-.005L13 .57 15.431 3 4.245 14.186l-.006.004-3.643 1.214L1.81 11.76zm8.829-8.686 2.286 2.286M2.639 11.075l2.286 2.286",
    stroke: "currentColor"
  })));
};

var EditOutline16Svg = SvgEditOutline16;

export { EditOutline16Svg as default };
//# sourceMappingURL=EditOutline16.svg.js.map
